import React from 'react';
import { prettyKey } from '../helpers/formatters';

const renderError = (key, value) => (
  <div className="error-details" key={key}>
    {typeof value !== 'object' && (
      <p className="text-danger">
        {prettyKey(key)}: {String(value)}
      </p>
    )}
    {typeof value === 'object' && value !== null && (
      <div className="text-danger">
        <p>{prettyKey(key)}:</p>
        <pre>
          {value && value.length && typeof value[0] === 'string'
            ? value.join('\n\r')
            : JSON.stringify(value, null, 2)}
        </pre>
      </div>
    )}
  </div>
);

const renderGenericError = (error) => {
  if (error.message || error.details) {
    return null;
  }

  return typeof error === 'object' ? (
    Object.keys(error).length &&
      Object.entries(error).map(([key, value]) => renderError(key, value))
  ) : (
    <p className="text-danger">{error}</p>
  );
};

export default ({ error }) => (
  <div className="errors">
    {error.message && <p className="text-danger">{error.message}</p>}
    {error.details &&
      error.details.map((detail) => renderError(detail.key, detail.value))}
    {renderGenericError(error)}
  </div>
);
